import { VIEW_BILLS, BILLS_LIST, ATTENDANCE, TASK_LIST, VIEW_MATERIAL_REQUESTS, DISPATCH_NOTE, PROCUREMENT_MRR, PROCUREMENT_GRN, ADVANCE_NOTES_LIST, GRN_LIST, RETURN_NOTE, SAN_LIST } from "../../routes";

export const NOTIFICATION_TEXT = {
    HEADER: "Notifications",
    NO_NOTIFICATIONS: "No notifications",
    MARK_ALL_AS_READ: "Mark all as read",
    FETCH_FAILED: "Failed to fetch notifications.",
    FETCH_ERROR: "Error fetching notifications.",
    MARK_READ_FAILED: "Failed to mark notifications as read.",
    MARK_READ_ERROR: "Error marking notifications as read.",
};

export const MESSAGES_TYPE = {
    INFO: "INFO",
    SUCCESS: "SUCCESS",
    WARNING: "WARNING",
    ERROR: "ERROR",
}

export const NOTIFICATIONS_TYPE = {
    ATTENDANCE: "attendance",
    BILL: "bill",
    TASK: "task",
    MRR: "mrr",
    DISPATCH_NOTE: "dispatch_note",
    GRN: "grn",
    RETURN_NOTE: "return_note",
    PMRR: "pmrr",
    PGRN: "pgrn",
    ADVANCE_NOTE: "advance_note",
    SAN: "stock_adjustment_note",
}

 export const notificationRoutes = {
    [NOTIFICATIONS_TYPE.BILL]: BILLS_LIST,
    [NOTIFICATIONS_TYPE.ATTENDANCE]: ATTENDANCE,
    [NOTIFICATIONS_TYPE.TASK]: TASK_LIST,
    [NOTIFICATIONS_TYPE.MRR]: VIEW_MATERIAL_REQUESTS, 
    [NOTIFICATIONS_TYPE.DISPATCH_NOTE]: DISPATCH_NOTE,
    [NOTIFICATIONS_TYPE.GRN]: GRN_LIST,
    [NOTIFICATIONS_TYPE.RETURN_NOTE]: RETURN_NOTE,
    [NOTIFICATIONS_TYPE.PMRR]: PROCUREMENT_MRR,
    [NOTIFICATIONS_TYPE.PGRN]: PROCUREMENT_GRN,
    [NOTIFICATIONS_TYPE.ADVANCE_NOTE]: ADVANCE_NOTES_LIST,
    [NOTIFICATIONS_TYPE.SAN]: SAN_LIST,
  };

export const MARK_AS_READ="Mark As Read"

